import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { BarChartComponent } from './bar-chart.component';
import { ProgressSpinnerModule } from '../progress-spinner/progress-spinner.module';
import { InitializeChartUtility } from '@twaice-fe/frontend/shared/utilities';

@NgModule({
  declarations: [BarChartComponent],
  imports: [CommonModule, ProgressSpinnerModule],
  exports: [BarChartComponent],
  providers: [InitializeChartUtility, DatePipe],
})
export class BarChartModule {}
